import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { KEYS_CHARCODE } from 'wix-rich-content-editor-common';
import { alignmentsMap, defaultAlignments } from '../../buttons/NodeAlignmentButton/consts.js';
import DropdownModal from './DropdownModal.js';
import ListItemSelect from '../ListItem/ListItemSelect.js';
import ListItemToggle from '../ListItem/ListItemToggle.js';
import ListItemSection from '../ListItem/ListItemSection.js';
import '../../icons/AlignLeftIcon.js';
import '../../icons/AlignCenterIcon.js';
import '../../icons/AlignRightIcon.js';
import 'wix-rich-content-ui-components';
import '../../style-inject.es-746bb8ed.js';
import 'classnames';
import 'wix-rich-content-common/libs/Tooltip';

const AlignmentPanel = ({
  getSelectedAlignment,
  onClick,
  options,
  getSelectedTextWrap,
  onTextWrapToggle
}) => {
  var _a;
  const { t, experiments, jsdomMode } = useContext(RicosContext) || {};
  const showTextwrap = (_a = experiments == null ? void 0 : experiments.alignmentWithTextwrap) == null ? void 0 : _a.enabled;
  const OPTIONS = options ? options.map((option) => alignmentsMap[option]) : defaultAlignments;
  const onKeyDown = (e, commandKey) => {
    if (e.keyCode === KEYS_CHARCODE.ENTER) {
      onClick(commandKey);
      e.stopPropagation();
    }
  };
  const alignmentOptions = OPTIONS.filter(
    (option) => ["LEFT", "RIGHT", "CENTER"].includes(option.commandKey)
  );
  const textWrapOption = OPTIONS.find((option) => option.commandKey === "TEXT_WRAP");
  const AlignmentDropdownOptions = alignmentOptions.map(
    ({ dataHook, icon: Icon, text, commandKey, tooltip }) => /* @__PURE__ */ React.createElement(
      ListItemSelect,
      {
        key: commandKey,
        dataHook,
        prefix: /* @__PURE__ */ React.createElement(Icon, null),
        title: t(text),
        selected: commandKey === getSelectedAlignment(),
        tooltip: t(tooltip),
        onKeyDown: (e) => {
          onKeyDown(e, commandKey);
        },
        onClick: () => onClick(commandKey)
      }
    )
  );
  const getTextwrapDropdownOption = () => /* @__PURE__ */ React.createElement(
    ListItemToggle,
    {
      key: textWrapOption.commandKey,
      dataHook: textWrapOption.dataHook,
      onChange: onTextWrapToggle,
      title: t(textWrapOption.text),
      selected: getSelectedTextWrap == null ? void 0 : getSelectedTextWrap()
    }
  );
  const separator = /* @__PURE__ */ React.createElement(ListItemSection, { type: "divider" });
  const DropdownOptions = showTextwrap && textWrapOption ? [...AlignmentDropdownOptions, separator, getTextwrapDropdownOption()] : [...AlignmentDropdownOptions];
  return /* @__PURE__ */ React.createElement(DropdownModal, { options: DropdownOptions, jsdomMode });
};

export { AlignmentPanel as default };
//# sourceMappingURL=AlignmentPanel.js.map
